export default "__VITE_ASSET__B2z1Bd3x__"